import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NestApiProvider } from '../../nest-api';
import { ResponseGetOrgStructDto, ResponseGetPositionDto } from '../dto/sunfish.dto';

@Injectable()
export class SunfishNestApi {
  private service: string = '';
  private model: string = 'sunfish';

  constructor(private nestApiProvider: NestApiProvider) {

  }

  getPosition(): Observable<ResponseGetPositionDto> {
    const method: string = 'GET';
    const func: string = 'getPosition';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetPositionDto>(method, url, func, params, body);
  }

  getOrgStruct(param: any): Observable<ResponseGetOrgStructDto> {
    const method: string = 'GET';
    const func: string = 'getOrgStruct';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof param !== 'undefined' && param !== null) urlParams.empId = param;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetOrgStructDto>(method, url, func, params, body);
  }

  public isAuthorizedUser(payload: { empId: any, accessCodes: any }): Observable<any> {
		const method: string = 'POST';
		const func: string = 'isAuthorizedUser';
		const params: any = payload || {};
		const urlParams: any = {};
		const body: any = {};
		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<any>(method, url, params, body, null);
	}

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sunfish.api.ts